import React from 'react'
import Layout from '../../components/layout'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import Meta from '../../components/meta'
import Stays from '../../components/stays'
import { rebuildFilters } from '../../lib/helpers'
import MetaHeader from '../../components/meta-header'
import {
  fetchFilterCategories,
  fetchFilterTypes,
  fetchPage,
} from '../../lib/api'

const Destinations = ({ data, filterTypes, filterCategories }) => {
  const { i18n } = useTranslation('common')

  return (
    <>
      {data && <Meta {...data.seoMetaData} />}
      <Layout alt active={'destinations'} flexColumn>
        <MetaHeader metaData={data.seoMetaData} />
        <Stays
          filterTypes={rebuildFilters(filterCategories, 'hotels')}
          headerFilterTypes={filterTypes || []}
          filterAreas={data.searchFilterAreas || []}
          filterTabs={
            data.searchTabs ? data.searchTabs.map((tab) => tab.searchTab) : []
          }
        />
      </Layout>
    </>
  )
}
export const getServerSideProps = async ({ locale, req }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      cookie: req.headers.cookie || '',
      ...(await fetchPage({ page: 'stays-page', locale })),
      ...(await fetchFilterTypes({ locale })),
      ...(await fetchFilterCategories({
        page: '/stays-page/filter-categories',
        locale,
      })),
    },
  }
}
export default Destinations
